module.exports = __webpack_public_path__ + "static/media/Spiritual_Judaism_desc.4fab3496.png";